module.exports = __webpack_public_path__ + "media/src/img/angel-main-bg-859473691454508d1fb548ff0f49b5da.png";